import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import FieldGenerator from '../../../../../../components/fields/generator';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getLatestPendingClassification, createClassification, getInstanceQuestions, saveAnswers } from '../../../../../../reducers/formInstances';
import { setProgressionProperties } from '../../../../../../reducers/onboarding';
import { parseAnswers, answersToInitialValuesWithAttributes } from '../../../../../../utilities/formInstances';
import { required } from '../../../../../../utilities/validation';
import mixpanel from 'mixpanel-browser';
class ClassificationStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'ClassificationStep' } });

        const { questions, job, client, getLatestPendingClassification, createClassification, getInstanceQuestions } = this.props;

        if (!questions) {
            getLatestPendingClassification(job.id, classification => {
                if (!classification) {
                    createClassification(job.id, client.admin_id, classification => {
                        getInstanceQuestions(classification.id);
                    });
                } else {
                    getInstanceQuestions(classification.id);
                }
            });
        }
    }

    submit(values, action) {
        const { questions, classification, saveAnswers, setProgressionProperties } = this.props;
        let answers = parseAnswers(classification.id, questions, values);
        saveAnswers(answers, () => {
            setProgressionProperties({ classificationAnswers: answers });
            action();
        });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, questions } = this.props;
        if (!questions) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        {questions.map((d, i) => <FieldGenerator key={i} definition={d} formName={'contractor-onboarding-wizard'} validate={required} />)}
                    </div>
                </div>

                <WizardButtons disabled={submitting} back={{ action: back }} />
            </form>
        );
    }
}

ClassificationStep = reduxForm(formSettings)(ClassificationStep);

const mapStateToProps = state => {
    let questions = state.formInstances.questions;
    let answers = questions ? questions.map(q => q.answer).filter(a => a !== undefined) : [];
    let questionAnswers = answers && answers.length ? answersToInitialValuesWithAttributes(answers) : {};

    return {
        questions,
        classification: state.formInstances.classification,
        admin: state.onboarding.admin,
        initialValues: { ...questionAnswers }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getLatestPendingClassification,
            createClassification,
            getInstanceQuestions,
            saveAnswers,
            setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClassificationStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/classification.jsx